import React, { useState, useEffect, useRef } from 'react'
import './News.css'
import { Link } from 'react-router-dom'

import TopBar from '../components/TopBar'
import Footer from '../components/Footer'


import Post1 from '../assets/Post1.webp'
import Post2 from '../assets/Post2.webp'

import Post3 from '../assets/Post3.webp'
import I from '../assets/111.svg'

import { motion as m } from "framer-motion";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import ScrollTrigger from 'gsap/ScrollTrigger';
import { useTranslation } from 'react-i18next'

gsap.registerPlugin(useGSAP);

const News = () => {
    
  const { i18n } = useTranslation();
  const { t } = useTranslation();
    //media query
    const [deviceWidth, setDeviceWidth] = useState(window.screen.width);

    useEffect(() => {
        const handleResize = () => {
            setDeviceWidth(window.screen.width);
        };
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        };
    }, []);

    //landing

    const element1Ref = useRef(null);
    const element2Ref = useRef(null);
    const element3Ref = useRef(null);
    const element4Ref = useRef(null);
    const element5Ref = useRef(null);


    useGSAP(() => {
        // Register the plugin
        gsap.registerPlugin(ScrollTrigger);

        //landing animation for the 'top' section        
        if (element1Ref && element1Ref.current) {
            gsap.from([element1Ref.current], {
                opacity: 0,
                x: "-=50",
                delay: 0.5,
                ease: "sine.out",
            });
        }

        if (element2Ref && element2Ref.current) {
            gsap.from([element2Ref.current], {
                opacity: 0,
                x: "+=50",
                delay: 0.5,
                ease: "sine.out",
            });
        }

        if (element3Ref && element3Ref.current)
            gsap.from([element3Ref.current, element4Ref.current, element5Ref.current], {
                opacity: 0,
                y: "+=50",
                delay: 0.5,
                stagger: 0.25,
                ease: "sine.out",
            });


    }, []);

    return (
        <m.div className="News"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: .25 }}
        >
            {/* <TopBar /> */}
            <div style={{ backgroundImage: `url(${I})` }} className="News-top">
                <div className="News-top-header">{t('NewsP1')}</div>
                <div className="News-top-text">{t('NewsP2')}</div>
            </div>
            {deviceWidth > 1023 && <> {/*<div className="News-bigcontent">
                <div className="News-bigcontent-element-big" ref={element1Ref}>
                    
                    <img loading="lazy" decoding="async" alt="" src={Photo} className="News-element-img" />
                    <div className="News-element-container">
                        <div className="News-element-container-top">
                            <div className="News-element-container-top-title">5 key generative AI use cases in insurance distribution</div>
                            <div className="News-element-container-top-text">With lots of unique blocks, you can easily build a page without coding. Build your next landing page.</div>
                        </div>
                        <div className="News-element-container-date">Aug 19, 2024</div>
                    </div>
                </div>

                <div className="News-bigcontent-element-small" ref={element2Ref}>
                    
                    <img loading="lazy" decoding="async" alt="" src={Photo1} className="News-element-img" />
                    <div className="News-element-container">
                        <div className="News-element-container-top">
                            <div className="News-element-container-top-title">5 key generative AI use cases in insurance distribution</div>
                            <div className="News-element-container-top-text">With lots of unique blocks, you can easily build a page without coding. Build your next landing page.</div>
                        </div>
                        <div className="News-element-container-date">Aug 19, 2024</div>
                    </div>
                </div>
    </div>*/}
                <div className="News-content">

                    <div className="News-content-element" ref={element3Ref}>
                        <Link to='/article1'></Link>
                        <img loading="lazy" decoding="async" alt="" src={Post1} className="News-element-img" />
                        <div className="News-element-container">
                            <div className="News-element-container-top">
                                {/*<div className="News-element-container-top-title">5 key generative AI use cases in insurance distribution</div>*/}
                                <div className="News-element-container-top-text">Sharing with you some photos from our latest seminar! It was a wonderful day filled with knowledge exchange and valuable connections. Thanks to everyone who</div>
                            </div>
                            <div className="News-element-container-date">Mar 6,2024</div>
                        </div>
                    </div>
                    <div className="News-content-element" ref={element4Ref}>
                        <Link to='/article2'></Link>
                        <img loading="lazy" decoding="async" alt="" src={Post2} className="News-element-img" />
                        <div className="News-element-container">
                            <div className="News-element-container-top">
                                {/*<div className="News-element-container-top-title">5 key generative AI use cases in insurance distribution</div>*/}
                                <div className="News-element-container-top-text">On March 5th, Khamsa Insurance and Reinsurance Brokers LLC, with the support of the Azerbaijan Banks Association and the British Chamber of Commerce Azerbaijan (BCCA), hosted a seminar titled "Secure the Boundaries" focusing on "Cyber Insurance and Directors and Officers (D&O) Insurance."</div>
                            </div>
                            <div className="News-element-container-date">Mar 6,2024</div>
                        </div>
                    </div>
                    <div className="News-content-element" ref={element5Ref}>
                        <Link to='/article3'></Link>
                        <img loading="lazy" decoding="async" alt="" src={Post3} className="News-element-img" />
                        <div className="News-element-container">
                            <div className="News-element-container-top">
                                {/*<div className="News-element-container-top-title">5 key generative AI use cases in insurance distribution</div>*/}
                                <div className="News-element-container-top-text">Dear Partners,
On 29 January, Khamsa Insurance and Reinsurance Brokers held an important event on "Safe Steps to Foundation in Post-Conflict Areas" at the initiative of the Central Bank of the Republic of Azerbaijan and with support of the Azerbaijan Insurers
                              </div>
                            </div>
                            <div className="News-element-container-date">Jan 30,2024</div>
                        </div>
                    </div>
                </div></>}
            {
                deviceWidth < 1024 &&
                <div className="News-content-responsive">
                     <div className="News-content-element" ref={element3Ref}>
                        <Link to='/article1'></Link>
                        <img loading="lazy" decoding="async" alt="" src={Post1} className="News-element-img" />
                        <div className="News-element-container">
                            <div className="News-element-container-top">
                                {/*<div className="News-element-container-top-title">5 key generative AI use cases in insurance distribution</div>*/}
                                <div className="News-element-container-top-text">Sharing with you some photos from our latest seminar! It was a wonderful day filled with knowledge exchange and valuable connections. Thanks to everyone who</div>
                            </div>
                            <div className="News-element-container-date">Mar 30,2024</div>
                        </div>
                    </div>
                    <div className="News-content-element" ref={element4Ref}>
                        <Link to='/article2'></Link>
                        <img loading="lazy" decoding="async" alt="" src={Post2} className="News-element-img" />
                        <div className="News-element-container">
                            <div className="News-element-container-top">
                                {/*<div className="News-element-container-top-title">5 key generative AI use cases in insurance distribution</div>*/}
                                <div className="News-element-container-top-text">On March 5th, Khamsa Insurance and Reinsurance Brokers LLC, with the support of the Azerbaijan Banks Association and the British Chamber of Commerce Azerbaijan (BCCA), hosted a seminar titled "Secure the Boundaries" focusing on "Cyber Insurance and Directors and Officers (D&O) Insurance."</div>
                            </div>
                            <div className="News-element-container-date">Mar 6,2024</div>
                        </div>
                    </div>
                    <div className="News-content-element" ref={element5Ref}>
                        <Link to='/article3'></Link>
                        <img loading="lazy" decoding="async" alt="" src={Post3} className="News-element-img" />
                        <div className="News-element-container">
                            <div className="News-element-container-top">
                                {/*<div className="News-element-container-top-title">5 key generative AI use cases in insurance distribution</div>*/}
                                <div className="News-element-container-top-text">Dear Partners,
On 29 January, Khamsa Insurance and Reinsurance Brokers held an important event on "Safe Steps to Foundation in Post-Conflict Areas" at the initiative of the Central Bank of the Republic of Azerbaijan and with support of the Azerbaijan Insurers
                              </div>
                            </div>
                            <div className="News-element-container-date">Jan 30,2024</div>
                        </div>
                    </div>
                    {/* deviceWidth > 767 &&
                        <div className="News-content-element">
                            <Link to='/article'></Link>
                            <img loading="lazy" decoding="async" alt="" src={Photo2} className="News-element-img" />
                            <div className="News-element-container">
                                <div className="News-element-container-top">
                                    <div className="News-element-container-top-title">5 key generative AI use cases in insurance distribution</div>
                                    <div className="News-element-container-top-text">With lots of unique blocks, you can easily build a page without coding. Build your next landing page.</div>
                                </div>
                                <div className="News-element-container-date">Aug 19, 2024</div>
                            </div>
                        </div>
                    */}
                </div>
            }
            <Footer />
        </m.div >
    )
}

export default News